import { render, staticRenderFns } from "./UserCircleSvg.vue?vue&type=template&id=f2163d4e&scoped=true"
import script from "./UserCircleSvg.vue?vue&type=script&lang=js"
export * from "./UserCircleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2163d4e",
  null
  
)

export default component.exports